import { render, staticRenderFns } from "./GiftCardReceived.vue?vue&type=template&id=894bc986&scoped=true&"
import script from "./GiftCardReceived.vue?vue&type=script&lang=js&"
export * from "./GiftCardReceived.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardReceived.vue?vue&type=style&index=0&id=894bc986&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894bc986",
  null
  
)

export default component.exports